
import React, { useEffect } from 'react'
import Gaurd from '../Util/Gaurd';
import { PageRoutes } from './config'
import { Route, Routes } from "react-router";
import PageNotFound from "../pages/PageNotFound/pageNotFound"
import AccessDenied from "../pages/AccessDenied/denied"
import LayoutClasses from 'Components/Layout/Layout.module.css'
import Login from "../pages/Login/index"

import Sidenav from 'Components/SideNav/Navbar';
import ActivityLog from '../pages/ActivityLog/log'
import TopNav from 'Components/topNav';
import useStore from 'store';
const Router = () => {
 const showNav = useStore((state) => state.showNavbar);
 const setShowNav = useStore((state) => state.setshowNavbar);
 const ActiveTab = useStore((State) => State.ActiveTab);
 const Token = useStore(item => item?.Token)
 const PageData = PageRoutes.map(({ path, element, AccessKey, Type }) => {
  if (AccessKey === 'login') {
   return <Route key={AccessKey} path={`/${path}`} element={element} />
  }
  else {
   return <Route path={path} key={AccessKey} element={<Gaurd Type={Type} element={element} permissions={AccessKey} key={AccessKey} />} />
  }
 })

 return (
  <>
   <Routes>   <Route key="login" path={`/`} element={<Login />} />,
    <Route key="ActivityLog" path={`/ActivityLog`} element={<ActivityLog />} />,
    <Route key="forbidden" path="/forbidden" element={<AccessDenied />} />,</Routes>
   {Token && Token.length > 0 &&
    <div className={LayoutClasses["Wrapper"]}>
     <Sidenav Active={ActiveTab} setShow={setShowNav} show={showNav} />

     <div
      className={`${LayoutClasses["main-content"]} ${!showNav ? LayoutClasses["nav-hide"] : ""
       }`}>
      <TopNav />
      <div style={{ zIndex: "2" }}>

       <Routes>{PageData} </Routes>
      </div>
     </div>
    </div>
   }
   {/*   <Routes>


   
   </Routes> */}
  </>
 )
}

export default Router